
/*
*  For now just augment logic to show the delete button.
*
* */

var DrawablePageNoteView = require('../drawableNote'),
    fvChannel = require('glRadio').channel('FV');

module.exports = DrawablePageNoteView.extend({


    templateHelpers: _.extend( _.clone( DrawablePageNoteView.prototype.templateHelpers), {

        /*
         *  Allow the current user if he created the note / users that belong to group type “ADMINISTRATOR” or “SUPERADMINISTRATOR”
         *  Note: N/A when note is 'new/creating' and other states.
         * */

        includeDeleteBtn: function() {

            // First Check 'Base Permission'
            if ( !DrawablePageNoteView.prototype.templateHelpers.includeDeleteBtn.apply( this, arguments ) )
                return false;

            var user = fvChannel.request('user'),  // TODO: pass in as param
                errorOccurredFetchingUserGroups = user.groups.length < 1,
                userCreatedNote = this.note.get('creationUser') === user.getUserID();
           
            return errorOccurredFetchingUserGroups
                ? userCreatedNote
                : userCreatedNote ||  _.contains(['SUPERADMINISTRATOR', 'ADMINISTRATOR'], user.groupStatus() );

      } 
        
    })


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/signature/signature.js
 ** module id = 298
 ** module chunks = 0
 **/